export default __webpack_public_path__ + "a99afedca980663059d5e21ce99cfbf3.png";